import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GrupoBeneficioPedidoAvulso } from 'src/models/interfaces/beneficios/beneficios.personalizados.interface';
import { HeadersService } from '../header.service';

@Injectable({
  providedIn: 'root'
})
export class EnderecoPersonalizadoService {
  private readonly url = `${environment.apiUrl}/api/v1/personalizados/enderecos`;
  private readonly grupoBeneficioUrl = `${environment.apiUrl}/api/v1/grupo-beneficios-especificos/personalizados/enderecos`;

  constructor(private readonly http: HttpClient, private headersService: HeadersService) {
    this.headersService.includeObject({ fileName: 'endereco.personalizado.service.ts', url: this.url });
    this.headersService.includeObject({ fileName: 'endereco.personalizado.service.ts', url: this.grupoBeneficioUrl });
  }

  public consultarEnderecosParaTratamentoDeErrosDoArquivoImportado(idClient: string): Observable<any> {
    return this.http
      .get<{ enderecos: any }>(`${this.url}/para-tratamento-de-erros`)
      .pipe(map((response) => response.enderecos));
  }

  public getEnderecosEntrega(flagExpress?: string, flagPosPago?: string, regiao?: string  ): Observable<HttpResponse<any>> {
    const queryParams: string[] = [];

    if (flagExpress) {
      queryParams.push(`flagExpress=${flagExpress}`);
    }
    if (flagPosPago) {
      queryParams.push(`flagPosPago=${flagPosPago}`);
    }

    if (regiao) {
      queryParams.push(`regiao=${regiao}`);
    }

    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
    const url = `${this.url}/de-entrega${queryString}`;

    return this.http.get<any>(url, { observe: 'response' });
  }

  public getBeneficiosPorEndereco(id: number): Observable<GrupoBeneficioPedidoAvulso[]> {
    const idParceria = localStorage.getItem('idParceria');
    return this.http
      .get<{ gruposBeneficio: GrupoBeneficioPedidoAvulso[] }>(
        `${this.grupoBeneficioUrl}/${id}?idParceria=${idParceria}`
      )
      .pipe(map((response) => (response && response.gruposBeneficio ? response.gruposBeneficio : [])));
  }
}
